import { Pipe, PipeTransform, inject } from "@angular/core";

import { AbstractTranslateService } from "@services";

@Pipe({ name: "mnTranslate" })
export class TranslatePipe implements PipeTransform {
  private readonly tS = inject(AbstractTranslateService);

  public transform(key: string, params?: Record<string, unknown>): string {
    return this.tS.translate<string>(key, params);
  }
}
